import React, { useCallback, useEffect, useState } from "react";
import ResuableTable from "../../../../components/ResuableTable/ResuableTable";
import { useDispatch } from "react-redux";
import functions from "../../../../utils/Api";
import { dispatchRefreshApiCallVendor } from "../../../../Redux/dispatcher";
import DiscardChangesDialog from "../../../../components/DiscardChangesDialog/DiscardChangesDialog";
import { setToasterStatusMsg } from "../../../../Redux/reportSlice";
import { Tabs, Tab, Box } from "@mui/material";

const VendorList = ({
  vendorListData,
  vendorData,
  setVendorData,
  locationId,
  searchUser,
  tableHeaders,
  renderCell,
  loadingBtn,
  setLoadingBtn,
  selectedUser,
  userDetailsChanges,
  setUserDetailsChanges,
  page,
  setPage,
}) => {
  const dispatcher = useDispatch();
  const [tabValue, setTabValue] = useState(0); // 0 for Active, 1 for Inactive
  const [activeCount, setActiveCount] = useState(0);
  const [inactiveCount, setInactiveCount] = useState(0);

  const vendorDetailsJson = useCallback(
    (data) => {
      let vendorDetails = data.length
        ? data.map((item) => ({
            id: item.vendorId,
            name: `${item.vendorName}`,
            email: item.vendorEmail,
            role: "vendor",
            locationName: item["Location.displayName"] || "_",
            status: item.isActive ? "Active" : "Inactive",
            contactNumber: item.vendorPhone || "",
            locationNameId: item.vendorLocationId || "",
          }))
        : [];
      setVendorData(vendorDetails);
    },
    [setVendorData]
  );

  const sortVendor = useCallback(() => {
    let sortedData = [...vendorListData].sort(
      (a, b) => a.vendorLocationId - b.vendorLocationId
    );
    return sortedData;
  }, [vendorListData]);

  useEffect(() => {
    let filterData = sortVendor();
    if (locationId) {
      filterData = filterData.filter(
        (item) => Number(item.vendorLocationId) === Number(locationId)
      );
    }
    if (searchUser) {
      filterData = filterData.filter((item) =>
        item.vendorName.toLowerCase().includes(searchUser.toLowerCase())
      );
    }

    const activeVendors = filterData.filter((item) => item.isActive);
    const inactiveVendors = filterData.filter((item) => !item.isActive);

    setActiveCount(activeVendors.length);
    setInactiveCount(inactiveVendors.length);

    vendorDetailsJson(tabValue === 0 ? activeVendors : inactiveVendors);
  }, [
    locationId,
    searchUser,
    sortVendor,
    vendorDetailsJson,
    vendorListData,
    tabValue,
  ]);

  const handleCreate = async () => {
    setLoadingBtn(true);
    let isActive = selectedUser.status === "Active" ? false : true;
    let updateVendorDetails = {
      vendorName: selectedUser.name,
      vendorLocationId: selectedUser.locationId,
      vendorEmail: selectedUser.email,
      vendorPhone: selectedUser.contactNumber,
      isActive: isActive,
    };
    if (updateVendorDetails) {
      try {
        let res = await functions.put(
          `/vendor/${selectedUser.id}`,
          updateVendorDetails
        );
        if (res) {
          dispatcher(dispatchRefreshApiCallVendor(true));
          setUserDetailsChanges(false);
          setLoadingBtn(false);
          dispatcher(
            setToasterStatusMsg({
              msg: `User ${
                isActive ? "Activated" : "Inactivated"
              } Successfully!`,
              severity: "success",
            })
          );
        }
      } catch (err) {
        setUserDetailsChanges(false);
        setLoadingBtn(false);
        dispatcher(
          setToasterStatusMsg({
            msg: `Error in ${
              isActive ? "Activating" : "Inactivating"
            } the User`,
            severity: "error",
          })
        );
        console.log(err);
      }
    }
  };

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
        >
          <Tab label={`Active (${activeCount})`} />
          <Tab label={`Inactive (${inactiveCount})`} />
        </Tabs>
      </Box>
      <ResuableTable
        userName="Employee"
        title="Manage Users"
        data={vendorData.length > 0 ? vendorData : []}
        tableHeader={tableHeaders}
        renderCell={renderCell}
        page={page}
        setPage={setPage}
      />
      {userDetailsChanges && (
        <DiscardChangesDialog
          title={`${
            selectedUser.status === "Active" ? "Inactivate" : "Activate"
          } Vendor`}
          text={`Are you sure you want to ${
            selectedUser.status === "Active" ? "Inactivate" : "Activate"
          }`}
          createBtn={`Yes ${
            selectedUser.status === "Active" ? "Inactivate" : "Activate"
          }`}
          user={selectedUser.name}
          open={userDetailsChanges}
          handleClose={setUserDetailsChanges}
          btnLoading={loadingBtn}
          setBtnLoading={setLoadingBtn}
          handleCreate={handleCreate}
        />
      )}
    </div>
  );
};

export default VendorList;
